import request from '@/utils/request'

// 查询设备数据列表
export function listDeviceData(query) {
  return request({
    url: '/iot/deviceData/list',
    method: 'get',
    params: query
  })
}

// 查询设备图表数据
export function queryChartData(data) {
  return request({
    url: '/iot/deviceData/queryChartData',
    method: 'post',
    data: data
  })
}

// 查询设备数据详细
export function getDeviceData(id) {
  return request({
    url: '/iot/deviceData/' + id,
    method: 'get'
  })
}

// 获取设备最新采集的数据
export function getLastDeviceData(id) {
  return request({
    url: '/iot/deviceData/last/' + id,
    method: 'get'
  })
}


// 向设备下发读取指令
export function doRequest(id) {
  return request({
    url: '/iot/deviceData/doRequest/' + id,
    method: 'get'
  })
}

// 修改数据点的数据值
export function modifyPointData(data) {
  return request({
    url: '/iot/deviceData/modifyPointData',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/deviceData.js